import type { BookLanguageRow } from '../../Settings/lists/singleTableListSupport';
import { BOOK_LANGUAGE_FORM_EN_ID } from '../../Settings/lists/bookLanguageFormSupport';
import { findFirstBookPagesMandatoryError } from './bookFormPagesMandatory';
import type { BookFormDraft } from './types';

export type ValidateBookFormDraftOptions = {
  /** When set (e.g. from `GET /book-language`), page text is not required for globally disabled languages. */
  displayBookLanguages?: BookLanguageRow[];
};

/** Step index aligned with `STEP_LABELS` in `bookForm/constants.ts` (0 = Хэл … 5 = Хуудсууд). */
export type BookFormValidationFailure = {
  message: string;
  stepIndex: number;
};

export function validateBookFormDraftDetailed(
  draft: BookFormDraft,
  options?: ValidateBookFormDraftOptions,
): BookFormValidationFailure | null {
  if (draft.mode === 'edit' && !draft.id.trim()) {
    return { message: 'ID алга.', stepIndex: 0 };
  }
  const anyLang = Object.entries(draft.language_enabled).some(([, v]) => v);
  if (!anyLang) {
    return { message: 'Дор хаяж нэг хэл идэвхжүүлнэ үү.', stepIndex: 0 };
  }
  if (!draft.author_id.trim()) {
    return { message: 'Зохиолч сонгоно уу.', stepIndex: 1 };
  }
  if (draft.category_ids.length === 0) {
    return { message: 'Дор хаяж нэг ангилал сонгоно уу.', stepIndex: 1 };
  }
  if (draft.age_group_ids.length === 0) {
    return { message: 'Дор хаяж нэг насны ангилал сонгоно уу.', stepIndex: 1 };
  }
  if (!draft.cover_image_path.trim() && !draft.cover_image_file) {
    return { message: 'Нүүр зураг заавал. «Зураг» алхмаас зураг сонгоно уу.', stepIndex: 2 };
  }
  if (draft.language_enabled[BOOK_LANGUAGE_FORM_EN_ID]) {
    const en = (draft.name_map[BOOK_LANGUAGE_FORM_EN_ID] ?? '').trim();
    if (!en) {
      return { message: 'Англи (en) гарчиг заавал бөглөнө.', stepIndex: 3 };
    }
  }

  if (draft.published) {
    const pageErr = findFirstBookPagesMandatoryError(draft, options?.displayBookLanguages);
    if (pageErr) {
      return { message: pageErr, stepIndex: 5 };
    }
  }

  return null;
}

export function validateBookFormDraft(draft: BookFormDraft, options?: ValidateBookFormDraftOptions): string | null {
  const d = validateBookFormDraftDetailed(draft, options);
  return d ? d.message : null;
}
